// A relay gift handed to this app in its address (docs/features/relay-passes.md › Gifts › From a phone): the gift
// page's **Send to my Mac** opens the app at `…#relayGift=rg_…`. A fragment never reaches a server; this takes the
// token out of it the moment the app starts — the address bar is put back without it (history.replaceState) — and
// hands it to the caller to keep in memory only: never in a query string, never in storage, never in the log.
//
// No DOM, no storage, no network: services/app/test/relaygift.test.mjs runs it under Node.
export const PARAM = 'relayGift'
const TOKEN = /^rg_[A-Za-z0-9_-]{43}$/

const params = (hash) => new URLSearchParams(String(hash || '').replace(/^#/, ''))

/// The gift's token in a fragment ('#relayGift=rg_…'), or null.
export function giftIn(hash) {
  const token = params(hash).get(PARAM)
  return token && TOKEN.test(token) ? token : null
}

/// Takes the gift out of the address → its token (null when there is none, or it is not a gift's). Whenever the
/// fragment names one, valid or not, the address bar is left without it; any other fragment parameter stays.
export function takeGift(loc = globalThis.location, hist = globalThis.history) {
  const rest = params(loc?.hash)
  if (!rest.has(PARAM)) return null
  const token = giftIn(loc.hash)
  rest.delete(PARAM)
  const left = rest.toString()
  hist.replaceState(null, '', loc.pathname + loc.search + (left ? '#' + left : ''))
  return token
}
